export function getAuthHeaders(accessToken: string) {
    return {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };
}